<template>
  <v-card
    class="mx-auto mb-7"
    width="80%"
  >
    <v-card-text>
      <v-container>
        <div class="text-h4">Order Finalization</div>
        <!-- <ESignature
          v-model="general.signature_name"
          :accepted.sync="general.forms_certified"
          acceptText="By signing you confirm the accuracy of the information you have provided."
        /> -->

        <v-btn
          class="mt-2"
          color="success"
          @click="submitOrder"
          :loading="isLoading"
          :disabled="isDisabled"
        >
          Submit Order
        </v-btn>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
// import ESignature from '@/components/formfields/ESignature.vue';

// signature_name
// completed

export default {
  name: 'SignNSubmitFrame',
  data() {
    return {
      general: {},
      isLoading: false,
    };
  },
  mounted() {
    this.general = _.cloneDeep(this.getFormData.general);
  },
  methods: {
    ...mapActions(['syncFormData', 'saveProgress']),
    submitOrder() {
      const vm = this;
      vm.general.completed = 'y';
      vm.completed = 'y';
      vm.sync();
      vm.isLoading = true;
      vm.saveProgress().then(() => {
        console.log('thank you');
      }).finally(() => {
        vm.isLoading = false;
      });
    },
    sync() {
      const vm = this;
      vm.syncFormData({
        mainKey: 'general',
        data: _.cloneDeep(vm.general),
      });
    },
  },
  computed: {
    ...mapGetters(['getFormData']),
    isDisabled() {
      return false;
    },
  },
};
</script>
